import { URL_SUPPORT_TERMS, URL_PRODUCT_TERMS } from '@seek/adv-constants';
import { createUrlResolver } from '@seek/melways-sites';
import { useLanguage, useTranslations } from '@vocab/react';
import { Stack, Text, TextLink } from 'braid-design-system';
import type { FC } from 'react';

import translations from '../../locales.vocab';
import { getSupportedLanguage } from '../../utils/getSupportedLanguage';

import type { HirerPaymentTermsProps } from './hirerPaymentTermsTypes';

const HirerPaymentTerms: FC<HirerPaymentTermsProps> = ({
  onClick,
  isAdBudgetSelected,
  useCase,
  site,
  isStaging,
}) => {
  const { language } = useLanguage();

  const urlResolver = createUrlResolver({
    site,
    language: getSupportedLanguage(language),
    staging: isStaging,
  });

  const supportTermsUrl = urlResolver({ path: URL_SUPPORT_TERMS });
  const productTermsUrl = urlResolver({ path: URL_PRODUCT_TERMS });
  const { t } = useTranslations(translations);

  if (isAdBudgetSelected) {
    return (
      <Stack space="medium">
        <Text size="small">
          {t('your ad budget will be activated immediately...')}
        </Text>
        <Text size="small">
          {t('by continuing you agree to use...', {
            AgreementTerms: (children: any) => (
              <TextLink
                href={`${productTermsUrl}#agreement-terms`}
                onClick={onClick}
                rel="noopener noreferrer"
                target="_blank"
                title="Agreement Terms"
              >
                {children}
              </TextLink>
            ),
            SupportTerms: (children: any) => (
              <TextLink
                href={supportTermsUrl}
                onClick={onClick}
                rel="noopener noreferrer"
                target="_blank"
                title="Advertising Terms of Use"
              >
                {children}
              </TextLink>
            ),
            ProductTerms: (children: any) => (
              <TextLink
                href={productTermsUrl}
                onClick={onClick}
                rel="noopener noreferrer"
                target="_blank"
                title="Product Terms"
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Stack>
    );
  } else if (useCase === 'ADBUDGET') {
    return (
      <Stack space="medium">
        <Text size="small">{t('ads posted using your Ad Budget...')}</Text>
        <Text size="small">
          {t('by continuing you agree to use...', {
            AgreementTerms: (children: any) => (
              <TextLink
                href={`${productTermsUrl}#agreement-terms`}
                onClick={onClick}
                rel="noopener noreferrer"
                target="_blank"
                title="Agreement Terms"
              >
                {children}
              </TextLink>
            ),
            SupportTerms: (children: any) => (
              <TextLink
                href={supportTermsUrl}
                onClick={onClick}
                rel="noopener noreferrer"
                target="_blank"
                title="Advertising Terms of Use"
              >
                {children}
              </TextLink>
            ),
            ProductTerms: (children: any) => (
              <TextLink
                href={productTermsUrl}
                onClick={onClick}
                rel="noopener noreferrer"
                target="_blank"
                title="Product Terms"
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Stack>
    );
  }
  return (
    <Text>
      {t('by continuing you agree to use this purchase...', {
        Terms: (children: any) => (
          <TextLink
            href={supportTermsUrl}
            onClick={onClick}
            rel="noopener noreferrer"
            target="_blank"
            title="Terms of use"
          >
            {children}
          </TextLink>
        ),
      })}
    </Text>
  );
};

export default HirerPaymentTerms;
